// Keep quick date selections relative to today while preserving custom dates.
export default function resolveStatsDateFilter(query, settings, calculateDateRange, validPresets) {
  const savedRange = settings?.rangePicker
  const savedPreset = validPresets.includes(settings?.activeButton) ? settings.activeButton : null
  const queryPreset = validPresets.includes(query.datePreset) ? query.datePreset : null
  const hasQueryRange = Boolean(query.from && query.to)
  const legacyPreset = hasQueryRange
    && savedPreset
    && Array.isArray(savedRange)
    && savedRange[0] === query.from
    && savedRange[1] === query.to
    ? savedPreset
    : null
  const preset = queryPreset || legacyPreset || (!hasQueryRange ? savedPreset : null)

  if (preset) {
    const { from, to } = calculateDateRange(preset)
    return { range: [from, to], preset }
  }
  if (hasQueryRange) return { range: [query.from, query.to], preset: null }
  if (Array.isArray(savedRange) && savedRange.length === 2) {
    return { range: savedRange, preset: null }
  }
  if (typeof savedRange === 'string') {
    return { range: [savedRange, savedRange], preset: null }
  }
  return null
}
